// source: https://restcountries.com/rest/v2/regionalbloc/eu?fields=name;alpha2Code;region

export const EUCountries = [
  {
    name: 'Austria',
    alpha2Code: 'AT',
    region: 'Europe',
  },
  {
    name: 'Belgium',
    alpha2Code: 'BE',
    region: 'Europe',
  },
  {
    name: 'Bulgaria',
    alpha2Code: 'BG',
    region: 'Europe',
  },
  {
    name: 'Croatia',
    alpha2Code: 'HR',
    region: 'Europe',
  },
  {
    name: 'Cyprus',
    alpha2Code: 'CY',
    region: 'Europe',
  },
  {
    name: 'Czech Republic',
    alpha2Code: 'CZ',
    region: 'Europe',
  },
  {
    name: 'Denmark',
    alpha2Code: 'DK',
    region: 'Europe',
  },
  {
    name: 'Estonia',
    alpha2Code: 'EE',
    region: 'Europe',
  },
  {
    name: 'Finland',
    alpha2Code: 'FI',
    region: 'Europe',
  },
  {
    name: 'France',
    alpha2Code: 'FR',
    region: 'Europe',
  },
  {
    name: 'Germany',
    alpha2Code: 'DE',
    region: 'Europe',
  },
  {
    name: 'Greece',
    alpha2Code: 'GR',
    region: 'Europe',
  },
  {
    name: 'Hungary',
    alpha2Code: 'HU',
    region: 'Europe',
  },
  {
    name: 'Ireland',
    alpha2Code: 'IE',
    region: 'Europe',
  },
  {
    name: 'Italy',
    alpha2Code: 'IT',
    region: 'Europe',
  },
  {
    name: 'Latvia',
    alpha2Code: 'LV',
    region: 'Europe',
  },
  {
    name: 'Lithuania',
    alpha2Code: 'LT',
    region: 'Europe',
  },
  {
    name: 'Luxembourg',
    alpha2Code: 'LU',
    region: 'Europe',
  },
  {
    name: 'Malta',
    alpha2Code: 'MT',
    region: 'Europe',
  },
  {
    name: 'Netherlands',
    alpha2Code: 'NL',
    region: 'Europe',
  },
  {
    name: 'Poland',
    alpha2Code: 'PL',
    region: 'Europe',
  },
  {
    name: 'Portugal',
    alpha2Code: 'PT',
    region: 'Europe',
  },
  {
    name: 'Romania',
    alpha2Code: 'RO',
    region: 'Europe',
  },
  {
    name: 'Slovakia',
    alpha2Code: 'SK',
    region: 'Europe',
  },
  {
    name: 'Slovenia',
    alpha2Code: 'SI',
    region: 'Europe',
  },
  {
    name: 'Spain',
    alpha2Code: 'ES',
    region: 'Europe',
  },
  {
    name: 'Sweden',
    alpha2Code: 'SE',
    region: 'Europe',
  },
];
